import { isServer } from "@converge-collective/common/util";

// ismorphic config - must work on both server and client
//

export const GoogleMapsApiKey = "AIzaSyABQlLAjH25W8oqX3ba3alAJnHV4G8YUho";

export const baseUrl = (): string => process?.env?.BASE_URL || "";

// we need to turn off bodyParser in production but keep it on in local dev
// since in production firease functions is already processing the req.body for
// us:
//
// https://firebase.google.com/docs/functions/http-events#read_values_from_the_request
export const apiConfig = isServer && {
  api: {
    bodyParser: process?.env?.BODY_PARSE_ENABLED === "true",
  },
};
